import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=754ed722&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('754ed722')) {
      api.createRecord('754ed722', component.options)
    } else {
      api.reload('754ed722', component.options)
    }
    module.hot.accept("./editor.vue?vue&type=template&id=754ed722&", function () {
      api.rerender('754ed722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/editor.vue"
export default component.exports